import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import './styles/index.css';

const ScrollButton = ({ label }) => {
  const [visible, setVisible] = useState(false);
  const scrollContainer = document.querySelector('.app-content');

  const toggleVisible = () => {
    const scrolled = scrollContainer.scrollTop;
    if (scrolled > 500) {
      setVisible(true);
    } else if (scrolled <= 500) {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', toggleVisible);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', toggleVisible);
      }
    };
  }, [scrollContainer]);

  const scrollToTop = () => {
    scrollContainer.scrollTo({
      top: 0,
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  return (
    <div
      className="scroll-to-top"
      onClick={scrollToTop}
      onKeyDown={scrollToTop}
      role="button"
      tabIndex={0}
      style={{ display: visible ? 'block' : 'none' }}
    >
      <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.91 9.41L8.5 2.83L15.09 9.41L16.5 8L8.5 0L0.5 8L1.91 9.41Z" fill="#FFFFFF" />
      </svg>
      <span>{label}</span>
    </div>
  );
};

ScrollButton.propTypes = {
  label: PropTypes.string
};

ScrollButton.defaultProps = {
  label: 'Back to Top'
};

export default ScrollButton;
